// Gets the default domain to query for visualizations.
export default () => window.location.hostname;
